/* eslint-disable camelcase */
/**
 * @author Fernando Ruano
 * @file index.jsx
 * @description Parameters Edit/View Page.
 */

// Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Components
import FormGenerator from '@nephro/components/FormGenerator';

// Helpers
import {
  getLastItemUrl,
  bottomOptionsCreateEdit,
  bottomOptionsRead,
  formItemParameters
} from '@nephro/commons/helpers/utils';

// Styles
import styles from './styles.module.css';

let parameterData = {};

/**
 * Parameters View/Edit
 * @param { Object } parameterActions - Parameter Actions.
 * @param { Object } actions - App Actions.
 * @return { Node } React node.
 */
const ParametersViewEdit = ({ parameterActions, actions }) => {
  const history = useHistory();
  const location = useLocation();
  const { t: translate } = useTranslation();

  const isView = location.pathname.includes('view');

  const [isReadOnly] = React.useState(isView);
  const [parameterInfo, setParameterInfo] = React.useState(null);
  const [parameterId] = React.useState(
    parseInt(getLastItemUrl(location.pathname), 10)
  );

  const { getParameterById, updateParameter } = parameterActions;
  const { setLoading } = actions;

  const onGoBack = () => {
    history.goBack();
  };

  // Function to get and set parameter info
  const onGetParameterInfo = (_, response) => {
    if (response.data) {
      const { param_key, param_value, param_description } = response.data;
      parameterData = { param_key, param_value, param_description };
      setParameterInfo(
        { param_key, param_value, param_description },
        setLoading(false)
      );
    } else {
      onGoBack();
    }
  };

  React.useEffect(() => {
    getParameterById({ id: parameterId }, onGetParameterInfo);
  }, []);

  // Function to get on submit form values
  const onFinish = (values) => {
    updateParameter({ ...values, id: parameterId }, onGoBack);
  };

  return (
    <div className="flex flex-col h-full px-7 pt-5 pb-7 ">
      {parameterInfo && (
        <FormGenerator
          initialValues={parameterData}
          onFinish={onFinish}
          items={formItemParameters(translate, isReadOnly)}
          bottomOptions={
            !isReadOnly
              ? bottomOptionsCreateEdit(
                  onGoBack,
                  translate,
                  'edit',
                  styles.actionButton
                )
              : bottomOptionsRead(onGoBack, translate, styles.actionButton)
          }
        />
      )}
    </div>
  );
};

/**
 * Component definition of proptypes.
 */
ParametersViewEdit.propTypes = {
  actions: PropTypes.shape({
    setLoading: PropTypes.func.isRequired
  }).isRequired,
  parameterActions: PropTypes.shape({
    getParameterById: PropTypes.func.isRequired,
    updateParameter: PropTypes.func.isRequired
  }).isRequired
};

export default ParametersViewEdit;
